import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { GridFour, CalendarStar, QrCode, House, SignOut, Ticket, Users, ClipboardText } from "@phosphor-icons/react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: GridFour, exact: true },
  { to: "/admin/events", label: "Kelola Acara", icon: CalendarStar },
  { to: "/admin/users", label: "Pengguna", icon: Users },
  { to: "/admin/attendance", label: "Daftar Hadir", icon: ClipboardText },
  { to: "/scan", label: "Scanner", icon: QrCode },
  { to: "/", label: "Lihat Situs", icon: House },
];

export function AdminLayout({ children, title }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-background flex">
      <aside className="w-16 md:w-60 border-r border-white/10 bg-black flex flex-col fixed h-full">
        <div className="h-16 flex items-center gap-2 px-4 border-b border-white/10">
          <div className="w-8 h-8 bg-primary flex items-center justify-center shrink-0">
            <Ticket weight="fill" size={20} className="text-black" />
          </div>
          <span className="font-heading font-black text-lg tracking-tighter hidden md:block">EVENT<span className="text-primary">KU</span></span>
        </div>
        <nav className="flex-1 py-4 space-y-1 px-2">
          {nav.map((n) => {
            const active = n.exact ? location.pathname === n.to : location.pathname.startsWith(n.to);
            return (
              <Link key={n.to} to={n.to} data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`flex items-center gap-3 px-3 py-2.5 text-sm font-semibold transition-colors ${active ? "bg-primary text-black" : "text-zinc-400 hover:text-white hover:bg-white/5"}`}>
                <n.icon size={20} weight={active ? "fill" : "regular"} className="shrink-0" />
                <span className="hidden md:block">{n.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="p-2 border-t border-white/10">
          <button onClick={() => { logout(); navigate("/"); }} data-testid="admin-logout"
            className="flex items-center gap-3 px-3 py-2.5 text-sm font-semibold text-zinc-400 hover:text-secondary w-full transition-colors">
            <SignOut size={20} className="shrink-0" /> <span className="hidden md:block">Keluar</span>
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-16 md:ml-60">
        <div className="h-16 border-b border-white/10 flex items-center px-6 justify-between bg-black/40 backdrop-blur-xl sticky top-0 z-20">
          <h1 className="font-heading text-xl font-bold tracking-tight">{title}</h1>
          <span className="text-sm text-zinc-500 hidden sm:block">{user?.email}</span>
        </div>
        <div className="p-6">{children}</div>
      </main>
    </div>
  );
}
